// extracted by mini-css-extract-plugin
module.exports = {"root":"GlitchSegmentedGroup_root__es0p3","content":"GlitchSegmentedGroup_content__AMGe1","halo":"GlitchSegmentedGroup_halo__KHjeC","noise":"GlitchSegmentedGroup_noise__cVl6y"};